import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/referral-program-hero.jpg'
import gridImage1 from 'assets/img/referral-program-1.jpg'
import gridImage2 from 'assets/img/referral-program-2.jpg'
import gridImage3 from 'assets/img/referral-program-3.jpg'
import gridImage4 from 'assets/img/referral-program-4.jpg'

export default function ReferralProgramPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Referral Program - Roaming Hunger</title>
        <meta name="og:title" content="Referral Program"></meta>
        <meta name="description" content="With a network of more than 23,000 food trucks, carts and caterers, Roaming Hunger is the leading provider of turnkey food truck catering and concessions. Below are a few reasons to eat with us."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Your Friend is Awesome."
          onButtonClick={openModal}
          description={(
            <div>
              Not only are they giving you $100 off your food truck catering,
              but they're also helping feed 100 people in need. Click Book Now to get started.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}

      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Book the perfect food truck for your birthday, office party, or any other event.
        </h2>
        <p className="font-light text-gray-900 mt-6">
          With a network of more than 23,000 food trucks, carts and caterers, Roaming Hunger
          is the leading provider of turnkey food truck catering and concessions. Below are
          a few reasons to eat with us.
        </p>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Save Time"
          content="Compare hundreds of food trucks in one place. We negotiate the best rate, coordinate logistics, and make sure the food truck shows up with everything you need. That gives you more time to salivate over the menu."
          image={gridImage1}
          reverse
        />
        <OccasionPageGridRow
          heading="Make Everyone Happy"
          content="Choose from thousands of cuisine options and let guests customize individual orders during your event. No matter the dietary requirements, every tastebud will be satisfied."
          image={gridImage2}
        />
      </OccasionPageGrid>

      <FeaturedClients
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Sit Back and Relax"
          content="Book your event with confidence knowing we have established relationships with the food trucks. We hold all funds until after your event, so we can guarantee youlll get fantastic service every time."
          image={gridImage3}
          reverse
        />
        <OccasionPageGridRow
          heading="RepEAT, RepEAT"
          content="Treat your guests to a delicious, unique meal again. Whether for a special celebration or every Friday, Roaming Hunger makes it simple to book another tasty event. Being the host with the most has never been easier."
          image={gridImage4}
        />
      </OccasionPageGrid>

      <Calculator
        heading="How Much Does Referral LP Catering Cost?"
        onButtonClick={openModal}
      />

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Referral LP Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Referral LP Catering Works"
        onButtonClick={openModal}
      />
    </Layout>
  )
}
